var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMetamaskLogo = function SvgMetamaskLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 38,
    viewBox: "0 0 200 38",
    fill: "#161616",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.779 19.1723C175.746 18.4948 174.606 18.013 173.527 17.4108C172.828 17.0193 172.083 16.673 171.475 16.1762C170.442 15.3331 170.655 13.6769 171.734 12.9542C173.284 11.9304 175.852 12.5025 176.126 14.5953C176.126 14.6405 176.171 14.6706 176.217 14.6706H178.558C178.618 14.6706 178.664 14.6254 178.649 14.5652C178.527 13.1198 177.965 11.9154 176.931 11.1475C175.943 10.4098 174.819 10.0183 173.618 10.0183C167.433 10.0183 166.87 16.5074 170.199 18.555C170.579 18.7959 173.846 20.4219 175.001 21.1296C176.156 21.8372 176.521 23.132 176.019 24.1558C175.564 25.0893 174.378 25.7367 173.193 25.6614C171.901 25.5861 170.898 24.8936 170.548 23.8095C170.487 23.6138 170.457 23.2374 170.457 23.0718C170.457 23.0266 170.411 22.9815 170.366 22.9815H167.828C167.782 22.9815 167.737 23.0266 167.737 23.0718C167.737 24.8936 168.193 25.9023 169.439 26.8207C170.609 27.694 171.886 28.0553 173.208 28.0553C176.673 28.0553 178.466 26.1131 178.831 24.0956C179.15 22.1233 178.557 20.3467 176.779 19.1723Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5793 10.3497H65.4547H64.2237C64.1781 10.3497 64.1477 10.3798 64.1325 10.41L62.0504 17.2152C62.02 17.3056 61.8984 17.3056 61.868 17.2152L59.7859 10.41C59.7707 10.3648 59.7403 10.3497 59.6947 10.3497H58.4637H57.339H55.8192C55.7736 10.3497 55.728 10.3949 55.728 10.4401V27.8146C55.728 27.8598 55.7736 27.9049 55.8192 27.9049H58.3573C58.4029 27.9049 58.4485 27.8598 58.4485 27.8146V14.6106C58.4485 14.5052 58.6004 14.4901 58.6308 14.5804L60.7281 21.4309L60.8801 21.9127C60.8953 21.9578 60.9257 21.9729 60.9713 21.9729H62.9166C62.9622 21.9729 62.9926 21.9428 63.0078 21.9127L63.1598 21.4309L65.2571 14.5804C65.2875 14.4751 65.4395 14.5052 65.4395 14.6106V27.8146C65.4395 27.8598 65.4851 27.9049 65.5307 27.9049H68.0687C68.1143 27.9049 68.1599 27.8598 68.1599 27.8146V10.4401C68.1599 10.3949 68.1143 10.3497 68.0687 10.3497H66.5793Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.918 10.3497C137.873 10.3497 137.842 10.3798 137.827 10.41L135.745 17.2152C135.714 17.3056 135.593 17.3056 135.563 17.2152L133.48 10.41C133.465 10.3648 133.435 10.3497 133.389 10.3497H129.529C129.483 10.3497 129.438 10.3949 129.438 10.4401V27.8146C129.438 27.8598 129.483 27.9049 129.529 27.9049H132.067C132.113 27.9049 132.158 27.8598 132.158 27.8146V14.6106C132.158 14.5052 132.31 14.4901 132.341 14.5804L134.438 21.4309L134.59 21.9127C134.605 21.9578 134.635 21.9729 134.681 21.9729H136.626C136.672 21.9729 136.702 21.9428 136.718 21.9127L136.87 21.4309L138.967 14.5804C138.997 14.4751 139.149 14.5052 139.149 14.6106V27.8146C139.149 27.8598 139.195 27.9049 139.24 27.9049H141.778C141.824 27.9049 141.87 27.8598 141.87 27.8146V10.4401C141.87 10.3949 141.824 10.3497 141.778 10.3497H137.918Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.182 10.3497H100.455H97.9174H93.1908C93.1452 10.3497 93.0996 10.3949 93.0996 10.4401V12.6081C93.0996 12.6533 93.1452 12.6985 93.1908 12.6985H97.8262V27.8146C97.8262 27.8598 97.8718 27.9049 97.9174 27.9049H100.455C100.501 27.9049 100.547 27.8598 100.547 27.8146V12.6985H105.182C105.228 12.6985 105.273 12.6533 105.273 12.6081V10.4401C105.273 10.3949 105.243 10.3497 105.182 10.3497Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.152 27.9049H122.462C122.523 27.9049 122.568 27.8446 122.553 27.7844L117.781 10.3497C117.766 10.3045 117.736 10.2894 117.69 10.2894H116.808H115.258H114.377C114.331 10.2894 114.301 10.3195 114.286 10.3497L109.513 27.7844C109.498 27.8446 109.544 27.9049 109.605 27.9049H111.915C111.96 27.9049 111.991 27.8747 112.006 27.8446L113.389 22.7708C113.404 22.7256 113.435 22.7106 113.48 22.7106H118.587C118.632 22.7106 118.663 22.7407 118.678 22.7708L120.061 27.8446C120.076 27.8747 120.122 27.9049 120.152 27.9049ZM114.088 20.2263L115.942 13.4361C115.973 13.3458 116.094 13.3458 116.125 13.4361L117.979 20.2263C117.994 20.2866 117.948 20.3468 117.887 20.3468H114.179C114.118 20.3468 114.073 20.2866 114.088 20.2263Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.545 27.9049H161.855C161.916 27.9049 161.961 27.8446 161.946 27.7844L157.174 10.3497C157.159 10.3045 157.128 10.2894 157.083 10.2894H156.201H154.651H153.77C153.724 10.2894 153.694 10.3195 153.678 10.3497L148.906 27.7844C148.891 27.8446 148.937 27.9049 148.997 27.9049H151.308C151.353 27.9049 151.384 27.8747 151.399 27.8446L152.782 22.7708C152.797 22.7256 152.827 22.7106 152.873 22.7106H157.979C158.025 22.7106 158.055 22.7407 158.071 22.7708L159.454 27.8446C159.469 27.8747 159.499 27.9049 159.545 27.9049ZM153.481 20.2263L155.335 13.4361C155.365 13.3458 155.487 13.3458 155.517 13.4361L157.372 20.2263C157.387 20.2866 157.341 20.3468 157.28 20.3468H153.572C153.511 20.3468 153.466 20.2866 153.481 20.2263Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4641 25.3302V19.9402C78.4641 19.895 78.5097 19.8499 78.5553 19.8499H85.3183C85.3639 19.8499 85.4095 19.8047 85.4095 19.7595V17.5915C85.4095 17.5463 85.3639 17.5011 85.3183 17.5011H78.5553C78.5097 17.5011 78.4641 17.456 78.4641 17.4108V12.8037C78.4641 12.7585 78.5097 12.7133 78.5553 12.7133H86.2454C86.291 12.7133 86.3366 12.6682 86.3366 12.623V10.455C86.3366 10.4098 86.291 10.3646 86.2454 10.3646H78.4641H75.8348C75.7892 10.3646 75.7437 10.4098 75.7437 10.455V12.7133V17.5162V19.8649V25.4356V27.8144C75.7437 27.8596 75.7892 27.9048 75.8348 27.9048H78.4641H86.5646C86.6102 27.9048 86.6558 27.8596 86.6558 27.8144V25.5259C86.6558 25.4808 86.6102 25.4356 86.5646 25.4356H78.5401C78.4945 25.4205 78.4641 25.3904 78.4641 25.3302Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199.971 27.7542L191.187 18.7658C191.157 18.7357 191.157 18.6755 191.187 18.6454L199.09 10.5152C199.151 10.455 199.105 10.3646 199.029 10.3646H195.792C195.762 10.3646 195.746 10.3797 195.731 10.3947L189.029 17.2903C188.968 17.3506 188.877 17.3054 188.877 17.2301V10.455C188.877 10.4098 188.831 10.3646 188.786 10.3646H186.248C186.202 10.3646 186.156 10.4098 186.156 10.455V27.8295C186.156 27.8747 186.202 27.9198 186.248 27.9198H188.786C188.831 27.9198 188.877 27.8747 188.877 27.8295V20.1811C188.877 20.1058 188.983 20.0606 189.029 20.1209L196.628 27.8897C196.643 27.9048 196.673 27.9198 196.689 27.9198H199.926C199.987 27.9048 200.032 27.7994 199.971 27.7542Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3868 1L23.0217 12.2919L25.8789 5.63722L38.3868 1Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94543 1L18.1738 12.3973L15.4533 5.63722L2.94543 1Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8547 27.1823L28.7665 33.3853L37.5205 35.7792L40.0281 27.3178L32.8547 27.1823Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31909 27.3178L3.81155 35.7792L12.5504 33.3853L8.47731 27.1823L1.31909 27.3178Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0793 16.7033L9.64758 20.3468L18.3104 20.7383L18.0216 11.4789L12.0793 16.7033Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2529 16.7033L23.2193 11.3735L23.0217 20.7383L31.6845 20.3469L29.2529 16.7033Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5503 33.3854L17.7936 30.871L13.2798 27.3781L12.5503 33.3854Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5385 30.871L28.7665 33.3854L28.0522 27.3781L23.5385 30.871Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7665 33.3854L23.5385 30.8711L23.964 34.2436L23.9184 35.6739L28.7665 33.3854Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5503 33.3854L17.4136 35.6739L17.3832 34.2436L17.7936 30.8711L12.5503 33.3854Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5049 25.1498L13.1583 23.8851L16.2283 22.4849L17.5049 25.1498Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8273 25.1498L25.1039 22.4849L28.1891 23.8851L23.8273 25.1498Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5503 33.3854L13.3102 27.1824L8.47729 27.3179L12.5503 33.3854Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0219 27.1824L28.7665 33.3854L32.8548 27.3179L28.0219 27.1824Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6844 20.3472L23.0216 20.7386L23.8271 25.15L25.1037 22.4851L28.1889 23.8853L31.6844 20.3472Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1582 23.8853L16.2282 22.4851L17.5048 25.15L18.3103 20.7386L9.64746 20.3472L13.1582 23.8853Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64758 20.347L13.2799 27.3782L13.1583 23.8852L9.64758 20.347Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.189 23.8853L28.0522 27.3783L31.6845 20.3472L28.189 23.8853Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3103 20.7386L17.5048 25.15L18.523 30.3594L18.751 23.4939L18.3103 20.7386Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0216 20.7386L22.5961 23.4788L22.8088 30.3594L23.8271 25.15L23.0216 20.7386Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8273 25.1496L22.8091 30.3589L23.5386 30.8708L28.0524 27.3779L28.1891 23.8849L23.8273 25.1496Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1583 23.8849L13.2799 27.3779L17.7937 30.8708L18.5232 30.3589L17.5049 25.1496L13.1583 23.8849Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9183 35.6738L23.9639 34.2434L23.5688 33.9122H17.7632L17.3832 34.2434L17.4136 35.6738L12.5503 33.3853L14.2525 34.7704L17.7024 37.1342H23.6144L27.0795 34.7704L28.7665 33.3853L23.9183 35.6738Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5386 30.8709L22.8091 30.359H18.5233L17.7938 30.8709L17.3834 34.2434L17.7634 33.9122H23.569L23.9641 34.2434L23.5386 30.8709Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0403 13.0297L40.3322 6.79653L38.3868 1L23.5385 11.9155L29.2529 16.7033L37.323 19.037L39.1011 16.9743L38.326 16.4173L39.5571 15.3031L38.6148 14.5804L39.8458 13.647L39.0403 13.0297Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.79653L2.30702 13.0297L1.47114 13.647L2.71737 14.5804L1.77509 15.3031L3.00613 16.4173L2.23103 16.9743L4.00919 19.037L12.0793 16.7033L17.7937 11.9155L2.94533 1L1 6.79653Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3231 19.037L29.253 16.7034L31.6847 20.3469L28.0524 27.378L32.8549 27.3178H40.0283L37.3231 19.037Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0792 16.7034L4.00912 19.037L1.31909 27.3178H8.47731L13.2799 27.378L9.64756 20.3469L12.0792 16.7034Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0218 20.7383L23.5385 11.9155L25.879 5.63721H15.4532L17.7937 11.9155L18.3105 20.7383L18.508 23.5086L18.5232 30.359H22.809L22.8242 23.5086L23.0218 20.7383Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.519033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMetamaskLogo;